import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import SeoContent from './components/SeoContent';
import FeaturedProducts from './components/FeaturedProducts';
import ArticleEntry from './components/ArticleEntry';
import CtaSection from './components/CtaSection';

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "YOYBUY Sheet",
  "url": "https://yoybuy.cfd/",
  "description": "YOYBUY Sheet — инновационная система покупок из Китая через spreadsheet. Экономьте до 60% на товарах с 1688, Taobao и других платформ. Полное руководство по использованию YOYBUY Spreadsheet.",
  "inLanguage": "ru",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://yoybuy.cfd/search?q={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <SeoContent />
        <FeaturedProducts />
        <ArticleEntry />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}